import { type TypePolicies } from "@apollo/client"

export const department: TypePolicies = {
  Department: {
    keyFields: ["id"],
    fields: {
      dataSource: {
        merge(existing, incoming) {
          return incoming ?? existing
        },
      },
    },
  },
}
